module.exports = __webpack_public_path__ + "static/media/green_check_icon.b6e13daf.svg";